/**
 * 判断两个新旧依赖数组数组是否相同 （同 Object.is 的判断逻辑）
 * @param oldDeps
 * @param deps
 */
export var isSameDeps = function isSameDeps(oldDeps, deps) {
  if (oldDeps === deps) return true;

  for (var i = 0; i < oldDeps.length; i++) {
    if (oldDeps[i] !== deps[i]) {
      return false;
    }
  }

  return true;
};